import React, { useRef } from 'react'
import styled from 'styled-components'

import AddButton from 'components/AddButton'
import Spinner from 'components/Spinner'

import List from 'pages/Notifications/List'

import { useStoreContext } from 'hooks/StoreContext'
import useNotificationRecipients from 'hooks/useNotificationRecipients'
import useAutoFocus from 'hooks/useAutoFocus'

import { color } from 'styles/colors'
import { PageHeader, PageTitle, screenSize, SinglePanePage } from 'styles/shared'

const Notifications = () => {
  useNotificationRecipients()

  const {
    notificationRecipients,
    areNotificationRecipientsLoaded
  } = useStoreContext()

  const title = useRef(null)
  useAutoFocus({ isLoaded: areNotificationRecipientsLoaded, element: title })

  return (
    <S.Container>
      <S.PageHeader>
        <PageTitle ref={title}>Notifications</PageTitle>
        <AddButton uri="/notifications/new" testId={'Add Recipient'}>Add Recipient</AddButton>
      </S.PageHeader>

      <S.SinglePanePage>
        <S.List>
          {areNotificationRecipientsLoaded ? (
            <List notificationRecipients={notificationRecipients} />
          ) : (
            <Spinner variant="page" />
          )}
        </S.List>
      </S.SinglePanePage>
    </S.Container>
  )
}

export default Notifications

const S = {
  Container: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
  `,
  PageHeader: styled(PageHeader)`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media ${screenSize.small} {
      flex-direction: column;
       align-items: end;
    }
  `,
  List: styled.div`
    height: 100%;
    width: 100%;
    padding: 20px;
    background-color: ${color('paneBackground')};
  `,
  SinglePanePage: styled(SinglePanePage)`
     @media ${screenSize.small} {
      margin-top: 0;
    }
  `
}
